<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue'
import { format, isValid, parse } from 'date-fns'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  modelValue: {
    type: [String, null],
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  prop: {
    type: String,
    default: null,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()
const emit = defineEmits(['update:modelValue'])
const date = ref<string | null>(null)

onMounted(() => {
  if (props.modelValue) {
    setDate(props.modelValue)
  }
})

const setDate = (dateString: string) => {
  let parsedDate = parse(dateString, 'dd-MM-yyyy', new Date())
  if (isValid(parsedDate)) {
    date.value = format(parsedDate, 'yyyy-MM-dd')
  } else {
    parsedDate = parse(dateString, 'yyyy-MM-dd', new Date())
    if (isValid(parsedDate)) {
      date.value = dateString
    } else {
      date.value = null
    }
  }
}

watch(
  () => props.modelValue,
  newValue => {
    if (newValue && newValue !== '1970-01-01') {
      setDate(newValue)
    } else {
      date.value = null
    }
  },
)

watch(date, newValue => {
  emit('update:modelValue', newValue ? format(new Date(newValue), 'yyyy-MM-dd') : null)
})
</script>

<template>
  <el-form-item
    class="w-100"
    :label="label ? $t(label) : ''"
    label-position="top"
    :prop="prop"
  >
    <el-date-picker
      class="w-100"
      :editable="false"
      v-model="date"
      type="date"
      format="DD-MM-YYYY"
      value-format="YYYY-MM-DD"
      placeholder="Pick a date"
      size="large"
      :clearable="clearable"
    />
  </el-form-item>
</template>
